import * as yup from 'yup';
import { checkDateIsStrictlyLower } from 'utils/date';

export const sortingCenterContractFormSchema = (pt: any, closureDate: Date): yup.AnyObjectSchema =>
  yup.object().shape({
    estimatedReceptionWeight: yup
      .number()
      .transform(value => (isNaN(value) ? undefined : value))
      .required(pt('validation.weight.required'))
      .typeError(pt('validation.weight.invalid'))
      .min(0, pt('validation.weight.invalid')),
    startDate: yup
      .date()
      .typeError(pt('validation.startDate.invalid'))
      .nullable()
      .required(pt('validation.startDate.required'))
      .test(
        'alreadyClosedMonth',
        pt('validation.startDate.alreadyClosedMonth'),
        (value, _) => !value || checkDateIsStrictlyLower(closureDate, value),
      )
      .when('endDate', {
        is: (endDate: Date | null) => !!endDate,
        then: yup
          .date()
          .typeError(pt('validation.startDate.invalid'))
          .nullable()
          .required(pt('validation.startDate.required'))
          .test('startDateValidation', pt('validation.startDate.greaterThanEndDate'), (value, context) => {
            const endDate = context.parent.endDate;
            return checkDateIsStrictlyLower(value, endDate);
          }),
      }),
    endDate: yup
      .date()
      .typeError(pt('validation.endDate.invalid'))
      .nullable()
      .required(pt('validation.endDate.required'))
      .test('endDateValidation', pt('validation.endDate.lesserThanStartDate'), (value, context) => {
        const startDate = context.parent.startDate;
        return !startDate || '' === startDate || checkDateIsStrictlyLower(startDate, value);
      })
      .test('alreadyClosedMonthFinalDate', pt('validation.endDate.alreadyClosedMonth'), (value, _) => {
        return checkDateIsStrictlyLower(closureDate, value);
      }),
    characterizationNumber: yup
      .number()
      .transform(value => (isNaN(value) ? null : value))
      .nullable()
      .typeError(pt('validation.characterizationNumber.invalid'))
      .moreThan(0, pt('validation.characterizationNumber.invalid'))
      .required(pt('validation.characterizationNumber.required')),
    client: yup.string().required(pt('validation.requiredClient')),
    stream: yup.string().required(pt('validation.requiredStream')),
  });
